module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"title":"Başlık","auditType":"Denetim Tipi","auditDate":"Denetim Tarihi","document":"Doküman","searchRecord":"Denetim Arama"},"en":{"title":"Title","auditType":"Audit Type","auditDate":"Audit Date","document":"Document","searchRecord":"Search Audit"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=1!./src/views/Audit/AuditRecords/Detail.vue
// module id = 1q1S
// module chunks = 1